module.exports = __webpack_public_path__ + "static/media/image-preview-storygame-mo.bb6ef0b5.png";